module.exports = __webpack_public_path__ + "static/media/brd.4a981acb.png";